import { Typography as MaterialTypography } from '@mui/material';
import classNames from 'classnames';
import { useTypography } from './hooks/useTypography';
import { useTypographyStyles } from './styles/typography.styles';
import { TypographyProps, TypographyVariants } from './typography.types';

/** @deprecated Use `components/v2/ui/Typography` instead. */
const Typography = ({
  children,
  variant = TypographyVariants.BODY1_5_REGULAR,
  ...props
}: TypographyProps) => {
  const { classes } = useTypographyStyles({ variant });

  const { materialEquivalentVariant } = useTypography({ variant });

  return (
    <MaterialTypography
      {...props}
      variant={materialEquivalentVariant}
      className={classNames(classes.variant, props.className)}
    >
      {children}
    </MaterialTypography>
  );
};

export default Typography;
